<template>
  <AdminPageView class="bg-light" :loading="loading">
    <div class="dropdown text-center">
      <button class="btn btn-link-primary btn-lg dropdown-toggle text-uppercase" type="button" data-bs-toggle="dropdown" aria-expanded="false">
        <span class="h2" style="display: inline-flex;max-width: 80vw;overflow: hidden;">{{ travel?.name ?? 'Sélectionner un séjour' }}</span>
      </button>
      <ul class="dropdown-menu">
        <li><a class="dropdown-item text-uppercase" href="#" v-for="travel in travels" :key="travel.id" @click="selectTravel(travel)">{{ travel.name }}</a></li>
      </ul>
    </div>

    <BoardTravelFilterBar v-model="filters" @reset-filters="resetFilters" class="col-12" />
    <div class="align-content-start d-flex flex-wrap gap-2">
      <ParticipantsCountWidget v-if="filters.statusFilter === 'all' || filters.statusFilter === 'inscrit'" />
      <ParticipantsCountsWidget/>
      <ParticipantsTransportWidget v-if="(filters.statusFilter === 'all' || filters.statusFilter === 'inscrit') && (travel?.transportations?.length ?? 0) > 0" />
      <ParticipantsTransportSplitWidget v-if="(filters.statusFilter === 'all' || filters.statusFilter === 'inscrit') && (travel?.transportations?.length ?? 0) > 0 && (!filters.transportFilter || filters.transportFilter != 'without')" />
      <ParticipantTransferSplitWidget v-if="(filters.statusFilter === 'all' || filters.statusFilter === 'inscrit') && (travel?.transfers?.length ?? 0) > 0" />
      <ParticipantsHotelSplitWidget v-if="(filters.statusFilter === 'all' || filters.statusFilter === 'inscrit') && (travel?.hotels?.length ?? 0) > 0" />
      <ParticipantsHotelSplitTypeWidget v-if="(filters.statusFilter === 'all' || filters.statusFilter === 'inscrit') && (travel?.hotels?.length ?? 0) > 0" />
      <!-- <ParticipantsTestWidget /> -->

    </div>
    <div class="align-content-start d-flex flex-wrap gap-2">
      <ParticipantsListWidget />
    </div>
  </AdminPageView>
</template>

<script setup lang="ts">
import { provide, ref, watchEffect } from 'vue';
import { useRouter } from 'vue-router';
import { useNotificationsStore } from '@/stores/notificationStore';
import adminApi from '@/api/adminApi'
import { BOARD_TRAVEL_KEY, BOARD_FILTERS_KEY } from '@/compositions/useBoardFilters'
import AdminPageView from '@/views/admin/AdminPageView.vue';
import BoardTravelFilterBar from '@/views/board/BoardTravelFilterBar.vue';
import ParticipantsCountWidget from '@/views/board/widgets/ParticipantsCountWidget.vue';
import ParticipantsCountsWidget from '@/views/board/widgets/ParticipantsCountsWidget.vue';
import ParticipantsTransportWidget from '@/views/board/widgets/ParticipantsTransportWidget.vue';
import ParticipantTransferSplitWidget from '@/views/board/widgets/ParticipantTransferSplitWidget.vue';
import ParticipantsTransportSplitWidget from '@/views/board/widgets/ParticipantsTransportSplitWidget.vue';
import ParticipantsHotelSplitWidget from '@/views/board/widgets/ParticipantsHotelSplitWidget.vue';
import ParticipantsHotelSplitTypeWidget from '@/views/board/widgets/ParticipantsHotelSplitTypeWidget.vue';
// import ParticipantsTestWidget from '@/views/board/widgets/ParticipantsTestWidget.vue';
import ParticipantsListWidget from '@/views/board/widgets/ParticipantsListWidget.vue';

const router = useRouter();
const notificationsStore = useNotificationsStore();

const loading = ref(true);
const travel = ref<AdminTravel>();
const props = defineProps<{id?: number, slug?: string}>()

const defaultFilters: BoardFilters = {
  statusFilter: 'all',
  hideOrganisateurs: false,
  hideCompanions: false,
  transportFilter: 'all',
  transportOption: null,
  transfertId: null,
  hotelRoomByName: null,
};

const filters = ref<BoardFilters>({...defaultFilters})

const currentBoard = ref<number>()
const travels = ref<{ id: number, name: string }[]>([])

provide(BOARD_TRAVEL_KEY, travel)
provide(BOARD_FILTERS_KEY, filters)

const resetFilters = () => {
  filters.value = { ...defaultFilters }
}

const selectTravel = (selectedTravel: { id: number, name: string }) => {
  if(selectedTravel.id === currentBoard.value) return;
  router.push({ name: 'travel-board-by-id', params: { id: selectedTravel.id } });
}

watchEffect(() => {
  if(props.id) {
    loading.value = true;
    adminApi.getTravel(props.id).then((response) => {
      travel.value = response.data;
      currentBoard.value = response.data.id;
      adminApi.getTravels().then((response) => {
        travels.value = response.data.items
          .filter((t) => t.endDate >= new Date())
          .map((t) => ({ id: t.id, name: t.name }))
          .sort((a: { name: string }, b: { name: string }) => a.name.localeCompare(b.name));
      }).catch((error: Error) => {
        notificationsStore.notifyError('Erreur lors du chargement de la page',error.message);
      });

    }).catch((error: Error) => {
      notificationsStore.notifyError('Erreur lors du chargement de la page',error.message);
      router.push({ name: 'home' });
    }).finally(() => {
      loading.value = false;
    });
  } else if(props.slug) {
    loading.value = true;
    adminApi.getTravelBySlug(props.slug).then((response) => {
      travel.value = response.data;
      currentBoard.value = response.data.id;
    }).catch((error: Error) => {
      notificationsStore.notifyError('Erreur lors du chargement de la page',error.message);
      router.push({ name: 'home' });
    }).finally(() => {
      loading.value = false;
    });
  } else {
    notificationsStore.notifyError('Aucun séjour trouvé', 'Identifiant de séjour manquant');
    router.push({ name: 'home' });
  }
});
</script>
